/**
 * cus-mega-menu.js — EChem Mega Menu interactions
 */
(function () {
  'use strict';

  var root = document.querySelector('.cmm-nav');
  if (!root) return;

  var isTouch = window.matchMedia('(hover: none)').matches;
  var barItems = root.querySelectorAll('.cmm-bar__item[data-cmm-has-panel]');
  var hamburger = root.querySelector('.cmm-hamburger');
  var drawer = root.querySelector('.cmm-drawer');
  var overlay = root.querySelector('.cmm-drawer-overlay');
  var closeBtn = root.querySelector('.cmm-drawer__close');

  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 200;

  /* Track which bar item has an active video — set BEFORE iframe is created */
  var videoLockedItem = null;

  /* ============================================
     Utility: open / close / closeAll
     ============================================ */
  function openPanel(item) {
    closeAllPanels(item);
    item.classList.add('cmm-item--open');
    var link = item.querySelector('.cmm-bar__link');
    var panel = item.querySelector('.cmm-panel');
    if (link) link.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closePanel(item) {
    item.classList.remove('cmm-item--open');
    var link = item.querySelector('.cmm-bar__link');
    var panel = item.querySelector('.cmm-panel');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      /* Stop any playing videos when panel closes */
      var activeVideos = panel.querySelectorAll('.cmm-video-lazy--active');
      activeVideos.forEach(function (v) {
        var iframe = v.querySelector('iframe');
        if (iframe) iframe.remove();
        v.classList.remove('cmm-video-lazy--active');
      });
    }
    if (videoLockedItem === item) videoLockedItem = null;
  }

  function closeAllPanels(except) {
    barItems.forEach(function (item) {
      if (item !== except) closePanel(item);
    });
  }

  /* ============================================
     Desktop: hover with debounce
     ============================================ */
  if (!isTouch) {
    barItems.forEach(function (item) {
      var openTimer = null;
      var closeTimer = null;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          openPanel(item);
        }, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        /* Don't auto-close if a video is playing inside this panel */
        if (videoLockedItem === item) return;
        closeTimer = setTimeout(function () {
          closePanel(item);
        }, CLOSE_DELAY);
      });
    });
  }

  /* ============================================
     Touch devices: click to toggle
     ============================================ */
  root.querySelectorAll('.cmm-bar__link[aria-haspopup="true"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!isTouch) return;
      e.preventDefault();
      var item = link.closest('.cmm-bar__item');
      if (item.classList.contains('cmm-item--open')) {
        closePanel(item);
      } else {
        openPanel(item);
      }
    });
  });

  /* ============================================
     Keyboard: focus management
     ============================================ */
  barItems.forEach(function (item) {
    var focusTimer = null;

    item.addEventListener('focusin', function () {
      clearTimeout(focusTimer);
      openPanel(item);
    });

    item.addEventListener('focusout', function () {
      focusTimer = setTimeout(function () {
        /* Don't close if video is playing (iframe steals focus) */
        if (videoLockedItem === item) return;
        if (!item.contains(document.activeElement)) {
          closePanel(item);
        }
      }, 100);
    });
  });

  /* ============================================
     Keyboard: Escape + ArrowDown
     ============================================ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = root.querySelector('.cmm-bar__item.cmm-item--open');
      if (open) {
        closePanel(open);
        var link = open.querySelector('.cmm-bar__link');
        if (link) link.focus();
        return;
      }
      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    }

    if (e.key === 'ArrowDown') {
      var focused = document.activeElement;
      if (focused && focused.classList.contains('cmm-bar__link') && focused.getAttribute('aria-haspopup') === 'true') {
        e.preventDefault();
        var item = focused.closest('.cmm-bar__item');
        openPanel(item);
        var firstLink = item.querySelector('.cmm-panel a');
        if (firstLink) firstLink.focus();
      }
    }
  });

  /* ============================================
     Outside click
     ============================================ */
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) {
      closeAllPanels();
    }
  });

  /* ============================================
     Mobile: drawer open / close
     ============================================ */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (hamburger) hamburger.focus();
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ============================================
     Mobile: accordion toggle
     ============================================ */
  root.querySelectorAll('.cmm-mobile__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.cmm-mobile__item');
      var sub = null;
      var children = item.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains('cmm-mobile__sub')) {
          sub = children[i];
          break;
        }
      }
      if (!sub) return;

      var isOpen = sub.classList.contains('is-open');

      if (isOpen) {
        sub.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        sub.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ============================================
     Lazy video: click thumbnail to load iframe
     ============================================ */
  root.addEventListener('click', function (e) {
    var playBtn = e.target.closest('.cmm-video-lazy__play');
    var thumb = e.target.closest('.cmm-video-lazy__thumb');
    var container = e.target.closest('.cmm-video-lazy');
    if (!container || container.classList.contains('cmm-video-lazy--active')) return;
    if (!playBtn && !thumb && e.target !== container) return;

    var embedUrl = container.getAttribute('data-embed-url');
    if (!embedUrl) return;

    /* Lock the panel BEFORE creating iframe (prevents mouseleave/focusout race) */
    var barItem = container.closest('.cmm-bar__item');
    if (barItem) videoLockedItem = barItem;

    var iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    container.appendChild(iframe);
    container.classList.add('cmm-video-lazy--active');
  });

  /* ============================================
     Sticky: IntersectionObserver
     ============================================ */
  var stickyEnabled = root.dataset.cmmSticky === 'true';
  var shadowEnabled = root.dataset.cmmShadow === 'true';

  if (stickyEnabled && shadowEnabled && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;margin-top:-1px;visibility:hidden;pointer-events:none;';
    root.parentNode.insertBefore(sentinel, root);

    new IntersectionObserver(function (entries) {
      root.classList.toggle('is-sticky', !entries[0].isIntersecting);
    }, { threshold: [1] }).observe(sentinel);
  }
})();
